import { FC } from "react";
import SpiderChart from "./spider-chart";
import React from "react";
import { Navbar, Container, Table } from "react-bootstrap";
import { AddBtn } from "./add-btn";
import { useStats } from "../queries/completion-queries";
import { useGoalsQuery } from "../queries/goal-queries";
import { Link, useNavigate } from "react-router-dom";

export const Stats: FC = () => {
    const nav = useNavigate()
    const { stats } = useStats()
    const { goals } = useGoalsQuery()

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">Stats</h2>
                </Container>
            </Navbar>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <SpiderChart data={stats} />
            </div>
            <Container className="mt-4">
                <span className="flex-row d-flex justify-content-between px-3">
                    <h3>Goals</h3>
                    <Link to="/create-goal">
                        <AddBtn />
                    </Link>
                </span>
                <Table>
                    <tbody>
                        {goals?.map((goal, index) => (
                            <tr key={index} onClick={() => nav('/goals/' + goal.id)}>
                                <td>
                                    <img
                                        src="/img/target.png"
                                        width="20"
                                        height="20"
                                        className="d-inline-block align-top"
                                        alt="target"
                                    />
                                </td>
                                <td className="text-start">{goal.title}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </>

    );
}